import { MyApp } from './../../../../app.component';
import { Component } from '@angular/core';

@Component({
    selector: 'gab-nav-component',
    templateUrl: 'navigation-container.component.html'
})

export class AppContainerComponent {
    public root: any;
    public rootParams: any;

    constructor() {
        this.root = MyApp;
    }
}



// WEBPACK FOOTER //
// ./src/app/features/shared/components/navigation-container/navigation-container.component.ts